import { cloneElement } from 'react';
import { Box } from '@zoopla-eng/zds-components/box';
import { Bulleted } from '@zoopla-eng/zds-components/lists/bulleted';
import {
    BarChartUpwardMedium,
    GeolocateMedium,
    PropertyManagementMedium,
} from '@zoopla-eng/zds-components/icons';
import RemortgageBanner from './remortgageBanner/remortgageBanner';
import {
    ExternalLinkSmall,
    ArrowRightMedium,
} from '@zoopla-eng/zds-components/icons';
import { bannerWrapper, rightBanner } from './banner.css';
import { EventNames, trackSegmentAndGAEvent } from '@zoopla/tracking';

const remortgageItems = [
    'Whether you can save money vs your current lender’s new deal',
    'LTV bands and additional borrowing',
    '2, 3, 5 or even 10-year deals',
];

const myHomeItems = [
    {
        id: 0,
        Icon: BarChartUpwardMedium,
        text: 'Keep track of your estimate',
    },
    {
        id: 1,
        Icon: GeolocateMedium,
        text: 'Stay of top of the local market',
    },
    {
        id: 2,
        Icon: PropertyManagementMedium,
        text: 'Get a free agent valuation',
    },
];

const RemortgageBannerCombination = () => {
    return (
        <Box display="flex" columnGap="S500" className={bannerWrapper}>
            <Box flex={1}>
                <RemortgageBanner
                    title="Free remortgage advice"
                    subtitle="We've partnered with Mojo to provide free independent remortgage advice."
                    body={
                        <>
                            <p>
                                Mojo's whole-of-market expert advisers can
                                compare deals from over 90 lenders.
                            </p>

                            <p>They'll answer your questions about:</p>
                            <Bulleted
                                items={remortgageItems.map((i, index) => (
                                    <span key={`item_${index}`}>{i}</span>
                                ))}
                            />
                        </>
                    }
                    partnership
                    ctaButton={{
                        url: 'https://zoopla.mojomortgages.com/get-started?utm_source=partner&utm_medium=zoopla&utm_campaign=InstantValHighIntentButton2',
                        text: 'Get expert mortgage advice',
                        icon: ExternalLinkSmall,
                        category: 'primary',
                        targetBlank: true,
                    }}
                    onClickTrackingFn={() =>
                        trackSegmentAndGAEvent(
                            EventNames.MOJO_OUTBOUND_CLICK,
                            {
                                eventCategory: 'home-values',
                                eventAction: 'click',
                                eventLabel: 'get_mortgage',
                            },
                            '/home-values/'
                        )
                    }
                    onLoadTrackingFn={() =>
                        trackSegmentAndGAEvent(
                            EventNames.MODULE_SHOWN,
                            {
                                eventCategory: 'home-values',
                                eventAction: 'module_shown',
                                eventLabel: 'remortgage_high_intent_button_2',
                            },
                            '/home-values/'
                        )
                    }
                />
            </Box>
            <Box display="flex" className={rightBanner}>
                <RemortgageBanner
                    subtitle="Get more insights with My Home"
                    body={
                        <>
                            {myHomeItems.map(({ Icon, text, id }) => (
                                <Box display="flex" columnGap="S200" key={id}>
                                    {cloneElement(<Icon />)}
                                    <p>{text}</p>
                                </Box>
                            ))}
                            <p>We created My Home just for you</p>
                        </>
                    }
                    bannerImage
                    ctaButton={{
                        url: `/myaccount/my-home/`,
                        text: 'Go to My Home',
                        icon: ArrowRightMedium,
                        category: 'secondary',
                    }}
                />
            </Box>
        </Box>
    );
};

export default RemortgageBannerCombination;
